module.exports = __webpack_public_path__ + "6ea2c6a2997cebfd0abbf58a45c64b8d.svg";